export const STARTUP_STAGES = [
  'Находим витрину',
  'Загружаем настройки',
  'Подключаем аккаунт',
  'Проверяем доступ',
  'Подготавливаем данные',
  'Открываем приложение',
] as const;

export function updateStartupLoader(stage: number): void {
  if (typeof document === 'undefined') return;
  const loader = document.getElementById('initial-loader');
  if (!loader) return;
  const normalized = Math.max(0, Math.min(STARTUP_STAGES.length - 1, Math.trunc(stage)));
  const percent = Math.round(12 + normalized * 17.6);
  loader.dataset.stage = String(normalized);
  loader.style.setProperty('--startup-progress', `${percent}%`);
  const status = document.getElementById('startup-status');
  if (status) status.textContent = STARTUP_STAGES[normalized];
  loader.querySelector('[role="progressbar"]')?.setAttribute('aria-valuenow', String(percent));
}
